import { render, staticRenderFns } from "./AboutUsManage.vue?vue&type=template&id=e70c6b62&scoped=true"
import script from "./AboutUsManage.vue?vue&type=script&lang=js"
export * from "./AboutUsManage.vue?vue&type=script&lang=js"
import style0 from "./AboutUsManage.vue?vue&type=style&index=0&id=e70c6b62&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e70c6b62",
  null
  
)

export default component.exports